import { CapoPlugin } from "/codebuild/output/src1120545451/src/consort-headless/nuxtapp/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];